import { render } from "./TheStudyBar.vue?vue&type=template&id=13657db8&scoped=true&ts=true"
import script from "./TheStudyBar.vue?vue&type=script&lang=ts"
export * from "./TheStudyBar.vue?vue&type=script&lang=ts"

import "./TheStudyBar.vue?vue&type=style&index=0&id=13657db8&scoped=true&lang=scss"

import exportComponent from "/data/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13657db8"]])

export default __exports__